import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Permissions } from "@main/permissions/permissions";
import { UserHelperService } from "@main/users/user-helper.service";
import { NamingConvention } from "@mipro/classes/naming-convention";
import { NamingConventionService } from "@mipro/services/naming-convention.service";
import { MenuItem } from "primeng/api";
import { firstValueFrom, map, Subscription } from "rxjs";

@Component({
    selector: "",
    template: `
        <div class="card">
            <p-tabMenu [model]="tabItems" [activeItem]="activeTab"></p-tabMenu>
            <router-outlet></router-outlet>
        </div>
    `
})
export class EditPlayerTabsComponent implements OnInit, OnDestroy {
    private ncSubs: Subscription;
    private patientId: string;
    private queryParams: Params;

    tabItems: MenuItem[];
    activeTab: MenuItem;

    constructor(
        private namingConvention: NamingConventionService,
        private userHelperService: UserHelperService,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {}

    async ngOnInit() {
        this.patientId = await firstValueFrom(this.activatedRoute.params.pipe(map(params => <string>params.id)));
        this.queryParams = await firstValueFrom(this.activatedRoute.queryParams);

        this.ncSubs = this.namingConvention.namingConvention$.subscribe(nc => this.createTabItems(nc));
    }

    ngOnDestroy(): void {
        this.ncSubs?.unsubscribe();
    }

    createTabItems(nc: NamingConvention) {
        this.tabItems = [
            {
                ...this.tabTitle(`Edit ${nc.singularEndUserNamingConvention}`),
                tabindex: "0",
                command: () => this.navigate()
            },
            {
                ...this.tabTitle("Organisations with Access Granted"),
                tabindex: "1",
                visible: this.userHelperService.hasPermission(Permissions.ManageOrganisationGrantAccess),
                command: () => this.navigate("granted-organizations", "1")
            }
        ];

        const tabIndex = this.queryParams.tabIndex;
        this.activeTab = this.tabItems.find(t => t.tabindex === tabIndex) ?? this.tabItems[0];
    }

    private tabTitle(title: string) {
        return { label: '<h5 class="mb-0">' + title + "</h5>", escape: false };
    }

    private navigate(segment?: string, tabIndex = "0") {
        const commands = ["/app/patients/edit", this.patientId];
        if (segment) {
            commands.push(segment);
        }

        const queryParams = { ...this.queryParams, tabIndex };
        this.router.navigate(commands, { queryParams });
    }
}
